// Mock data for Engr. Aliyu Aziz Abubakar's portfolio

export const personalInfo = {
  name: "Engr. Aliyu Aziz Abubakar",
  title: "Chartered Engineer & Digital Transformation Leader",
  tagline: "30+ Years of Excellence in Engineering, Technology Leadership & Digital Innovation",
  location: "Abuja, Nigeria",
  email: "aliyuaziz@aliyuaziz.com",
  phone: "+234 803 329 6553",
  profileImage: "https://customer-assets.emergentagent.com/job_tech-innovator-16/artifacts/o52iz0qe_AAA.jpg"
};

export const aboutMe = {
  summary: "Seasoned multidisciplinary Chartered Engineer with over 30 years of experience spanning engineering, information technology, management, and administration across both public and private sectors. Currently Principal Partner at Integrated Engineering Associates (IEA) and Adviser to the Board of the Africa Chamber of Digital Commerce (ACOFDC).",
  highlights: [
    "Former Director General/CEO of National Identity Management Commission (NIMC)",
    "Grew National Identity Database from 7 million to over 100 million NINs",
    "Secured $433 million in funding from World Bank and international partners",
    "Led development of Nigeria's Digital Identity Roadmap",
    "QGIS Expert and GIS specialist with 30+ years experience",
    "Fellow of multiple prestigious engineering institutions"
  ],
  education: [
    {
      degree: "PhD Reliability of Offshore Structures",
      school: "Federal University of Technology Akure",
      status: "In View"
    },
    {
      degree: "M.Sc. Structures",
      school: "Ahmadu Bello University Zaria",
      year: "1987"
    },
    {
      degree: "B.Eng Honours in Civil Engineering (2:1)",
      school: "Ahmadu Bello University Zaria", 
      year: "1983"
    }
  ]
};

export const skills = [
  {
    category: "Leadership & Management",
    items: [
      "Strategic Leadership",
      "Digital Transformation",
      "Public Sector Management", 
      "Team Leadership",
      "Project Management"
    ]
  },
  {
    category: "Technology & Engineering",
    items: [
      "Structural Engineering",
      "Geospatial Information Systems (GIS)",
      "QGIS Expert",
      "Blockchain Technology",
      "Cybersecurity",
      "Biometric Systems"
    ]
  },
  {
    category: "Programming & Analytics",
    items: [
      "Python",
      "Java",
      "PHP", 
      "C++",
      "Machine Learning",
      "Data Science",
      "Predictive Analytics"
    ]
  },
  {
    category: "Software & Tools",
    items: [
      "AutoCAD",
      "Revit Structures",
      "ArcGIS", 
      "Erdas Imagine",
      "LS-DYNA",
      "ANSYS"
    ]
  }
];

export const experience = [
  {
    company: "Integrated Engineering Associates",
    position: "Principal Partner",
    period: "September 2023 – Present",
    location: "Abuja, Nigeria",
    description: "Overseeing the Structural, Electrical and Mechanical Engineering design office.",
    achievements: []
  },
  {
    company: "National Identity Management Commission (NIMC)",
    position: "Director General/Chief Executive Officer", 
    period: "November 2015 – August 2023",
    location: "Abuja, Nigeria",
    description: "Led the exponential transformation of Nigeria's digital identity infrastructure.",
    achievements: [
      "Grew National Identity Database from 7 million to 100 million NINs",
      "Increased enrollment centers from 431 to over 15,000 nationwide",
      "Secured $433 million funding from World Bank, AFD, and EIB",
      "Developed Strategic Roadmap for Digital Identity Ecosystem",
      "Launched Africa's first Blockchain-based MobileID ecosystem (ranked 3rd globally)",
      "Led NIN-SIM linkage implementation for enhanced national security",
      "Established NIMC presence in all 774 Local Government Areas"
    ]
  },
  {
    company: "Federal Capital Territory Authority",
    position: "Special Adviser, Information Technology",
    period: "2004 – 2007", 
    location: "Abuja, Nigeria",
    description: "Provided visionary leadership in e-government initiatives and IT strategy.",
    achievements: [
      "Promoted e-government initiatives to improve service delivery",
      "Designed IT framework and policies for FCT agencies",
      "Streamlined IT operations across government departments"
    ]
  },
  {
    company: "Bureau of Public Enterprises (BPE)",
    position: "Head of IT Unit",
    period: "2002 – 2004",
    location: "Abuja, Nigeria", 
    description: "Led IT planning and implementation for privatization programs.",
    achievements: [
      "Developed IT framework and policies for BPE",
      "Coordinated organizational restructuring of priority sectors",
      "Managed strategic IT objectives and budgets"
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "National Identity Database Transformation",
    category: "Digital Identity",
    description: "Led the exponential growth of Nigeria's National Identity Database from 7 million to over 100 million NINs, establishing digital identity infrastructure nationwide.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop",
    technologies: ["Biometric Systems", "Database Management", "Cybersecurity", "API Development"],
    outcomes: [
      "1,400% database growth over 8 years",
      "15,000+ enrollment centers established",
      "Nationwide coverage in all 774 LGAs"
    ]
  },
  {
    id: 2,
    title: "Blockchain MobileID Ecosystem", 
    category: "Blockchain Technology",
    description: "Developed and deployed Africa's first Blockchain-based MobileID ecosystem, ranked 3rd globally by the World Bank and Open Standards Identity Alliance.",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=600&h=400&fit=crop",
    technologies: ["Blockchain", "Mobile Technology", "Digital Identity", "Cryptography"],
    outcomes: [
      "3rd global ranking by World Bank", 
      "First blockchain ID system in Africa",
      "Millions of daily authentications"
    ]
  },
  {
    id: 3,
    title: "Digital Identity Roadmap & $433M Funding",
    category: "Strategic Planning",
    description: "Envisioned and developed the Strategic Roadmap for Digital Identity Ecosystem in Nigeria, securing unprecedented international funding.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop",
    technologies: ["Strategic Planning", "International Relations", "Project Management", "Policy Development"],
    outcomes: [
      "$433M secured from World Bank, AFD, EIB",
      "200+ organizations licensed nationwide",
      "Federal Executive Council approval"
    ]
  },
  {
    id: 4,
    title: "GIS Mapping of Primary Health Care Centers",
    category: "Geospatial Engineering", 
    description: "Led comprehensive GIS mapping project for Primary Health Care Centers in Nasarawa State for the National Primary Health Care Development Agency.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=600&h=400&fit=crop",
    technologies: ["QGIS", "ArcGIS", "GPS Systems", "Spatial Analysis"],
    outcomes: [
      "Complete PHC mapping for Nasarawa State",
      "Enhanced healthcare accessibility data",
      "Improved resource allocation planning"
    ]
  },
  {
    id: 5,
    title: "Hadejia Valley Irrigation Project Mapping",
    category: "Land-use Analysis",
    description: "Project lead for comprehensive land-use mapping using high-resolution QuickBird satellite imagery and advanced GIS analysis.",
    image: "https://images.unsplash.com/photo-1574263867128-c8bb7e6c8a43?w=600&h=400&fit=crop", 
    technologies: ["Satellite Imagery", "Erdas Imagine", "ArcGIS", "Trimble GPS"],
    outcomes: [
      "High-resolution farm plot delineation",
      "Socio-economic farmer data mapping", 
      "Sub-meter accuracy GPS surveys"
    ]
  },
  {
    id: 6,
    title: "NIN-SIM Linkage Implementation",
    category: "National Security",
    description: "Executed Presidential directive for linking National Identification Numbers with SIM cards, enhancing national security infrastructure.",
    image: "https://images.unsplash.com/photo-1563906267088-b029e7101114?w=600&h=400&fit=crop",
    technologies: ["Database Integration", "API Development", "Security Protocols", "Telecommunications"],
    outcomes: [
      "Enhanced national security framework",
      "Improved SIM card registration policy",
      "Reduced identity fraud in telecommunications"
    ]
  }
];

export const awards = [
  {
    title: "Digital Economy Enabler of the Year",
    organization: "Nigerian NewsDirect",
    year: "2023"
  },
  {
    title: "Most Proactive DG/CEO in Database Management",
    organization: "Institute of Strategic & Security Studies", 
    year: "2022"
  },
  {
    title: "Best Public Sector Social Media for Citizens' Engagement",
    organization: "DigiVation Network - African Future Summit",
    year: "2022"
  },
  {
    title: "1st Place - Federal Government Website Ranking",
    organization: "Bureau of Public Service Reforms (BPSR)",
    year: "2020"
  }
];

export const certifications = [
  "Chartered Engineer – COREN",
  "Fellow – Nigerian Institution of Structural Engineers",
  "Fellow – Institute of Information Management",
  "QGIS Expert Certification",
  "Lifetime Member - GIS and Earth Observation University",
  "Data Science and Machine Learning - MIT",
  "Digital Transformation - MIT",
  "Executive Program - Stanford University",
  "Executive Program - Harvard Business School"
];